import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {PageControlBar} from 'shells/control-bar/page-control-bar';
// @ts-expect-error - imported from .js/.jsx file
import {CogIcon} from 'shells/icon/svg/cog-icon';
// @ts-expect-error - imported from .js/.jsx file
import {HorizontalChartIcon} from 'shells/icon/svg/horizontal-chart-icon';
import {PageTitleBar} from 'shells/layout/page-title-bar';
import {TabbedContent} from 'shells/layout/tabbed-content';
import {LoadingPage} from 'shells/loading-page/loading-page';

import {PageContainer} from '../../layout';
import {downloadReport} from '../../reports/download-report';

import {CHARTS_DIV_ID} from './competitors-charts';
import {CompetitorsChartsWrapper} from './competitors-charts-wrapper';
import type {CompetitorsPageTab} from './competitors-page-wrapper';
import {GetStartedEmptyState} from './empty-states';
import {useShowGetStarted} from './graphql/hooks';
import {getTab} from './helpers';
import {Settings} from './settings';

type Props = ContextRouter & {
    getPathForTab: (tab: CompetitorsPageTab) => string;
    activeTab: CompetitorsPageTab;
    onChangeTab: (newTab: CompetitorsPageTab) => void;
};

export function CompetitorsPage(props: Props) {
    const {getPathForTab, activeTab, onChangeTab} = props;

    const tabOptions = [
        {
            id: 'charts',
            label: 'Competitors',
            icon: HorizontalChartIcon,
            href: getPathForTab('charts'),
            component: <CompetitorsChartsWrapper onGoToSettings={() => onChangeTab('settings')} />,
        },
        {
            id: 'settings',
            label: 'Settings',
            icon: CogIcon,
            href: getPathForTab('settings'),
            component: <Settings />,
        },
    ];

    const {shouldShowGetStarted, isLoading} = useShowGetStarted();

    const content = shouldShowGetStarted ? (
        <GetStartedEmptyState />
    ) : (
        // @ts-expect-error
        <TabbedContent selectedTab={activeTab} tabOptions={tabOptions} />
    );

    const handleDownloadCharts = () =>
        downloadReport({
            chartSelector: `#${CHARTS_DIV_ID}`,
            trackingParams: {
                report: 'competitoriq',
            },
            reportTitle: 'CompetitorSpy Reports.png',
        });

    return (
        <PageContainer
            title='CompetitorSpy'
            pageTitleBar={
                <PageTitleBar
                    title='CompetitorSpy'
                    subheaderPrimaryText='Keep an eye on your competitors’ traffic'
                    buttons={
                        <ActionMenu
                            options={[
                                {
                                    label: 'Download report',
                                    handleSelect: handleDownloadCharts,
                                },
                            ]}
                        />
                    }
                />
            }
            controlBar={
                <PageControlBar
                    tabs={{
                        selectedTab: activeTab,
                        options: tabOptions,
                        onChangeTab: (newTab) => {
                            onChangeTab(getTab(newTab));
                        },
                    }}
                />
            }
        >
            <>
                {isLoading && <LoadingPage padding={0} />}
                {!isLoading && content}
            </>
        </PageContainer>
    );
}
